import { render } from "./serviceRepairTable.vue?vue&type=template&id=9cb1b284"
import script from "./serviceRepairTable.vue?vue&type=script&lang=js"
export * from "./serviceRepairTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__